/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Tue Oct 22 2024
 **/

import { forwardRef } from "react";

import { GROUP_POPOVER_ID, POPOVER_ID } from "@/frameworks/core/commons";
import { usePersistUser } from "@/frameworks/core/persistence";
import * as S from "./private/emotion";
import { Loader } from "@/frameworks/designStuff/components";
import CompundMiniProfile from "./private/CompoundMiniProfile";
/**
 * !important: don't write service logic in component. write service logic in child component.
 */

const MiniProfile = forwardRef<HTMLDivElement, { userID: string; popoverID?: GROUP_POPOVER_ID | POPOVER_ID }>(
	({ userID, popoverID = GROUP_POPOVER_ID.AVATAR_MINI_PROFILE }, ref) => {
		const user = usePersistUser(userID);

		return (
			<>
				<ProfileBaseTemplate
					container={{
						render: () => {
							return (
								<S.MiniProfileWrapper ref={ref}>
									{user ? <CompundMiniProfile userData={user} popoverID={popoverID} /> : <Loader />}
								</S.MiniProfileWrapper>
							);
						}
					}}
				/>
			</>
		);
	}
);

export default MiniProfile;

type CommonTemplateOptions = {
	container: {
		render: () => React.ReactNode;
	};
};

const ProfileBaseTemplate = (props: CommonTemplateOptions) => {
	return <>{props.container.render()}</>;
};
